import React from 'react';
import { Route, Redirect } from 'react-router-dom';

function PrivateRoute(props) {
  const { component: Component, ...rest } = props;
  let orgType = localStorage.getItem('orgType');
  let userAccessToken = localStorage.getItem('userAccessToken');

  return <Route {...rest} render={(props) => ((orgType !== null && orgType === 'certifier') || userAccessToken !== null ? <Component {...props} /> : <Redirect to='/' />)} />;
}

export default PrivateRoute;
